import { useState } from "react";
import ReactSelect from "react-tailwindcss-select";
import "./styles.css";

const BoardSelect = ({
  options,
  formik,
  name,
  onChange,
  label,
  placeholder,
  onSearch,
  menuClassName,
}) => {
  const [value, setValue] = useState(null);
  const handleSelect = (val) => {
    setValue(val);
    formik?.setFieldValue(name, val);
    if (onChange) {
      onChange(val);
    }
  };
  const required = Object.keys(formik.initialValues).some((key) => key === name);

  return (
    <div className="my-4">
      {label && (
        <label className="block mb-1 font-medium capitalize dark:text-white text-mainGray">
          {label}
          {label && required && <span className="text-mainRed">*</span>}
        </label>
      )}
      <ReactSelect
        value={value}
        options={options || []}
        placeholder={placeholder}
        onSearchInputChange={onSearch}
        onChange={handleSelect}
        classNames={{
          menuButton: ({ isDisabled }) =>
            `flex text-sm text-mainGray select-menu px-2 h-[40px] border border-[#E5E7FB] rounded-[5px] transition-all duration-300 focus:outline-none  ${
              isDisabled
                ? "bg-gray-200"
                : "bg-white hover:border-gray-400 focus:border-blue-500 focus:ring focus:ring-blue-500/20"
            } ${menuClassName}`,
          listItem: ({ isSelected }) =>
            `block transition duration-200 px-2 py-2 cursor-pointer select-none truncate  ${
              isSelected
                ? `text-white bg-blue-500`
                : `text-gray-500 hover:bg-blue-100 hover:text-blue-500`
            }`,
          menu: "absolute z-10 w-full bg-white shadow-lg border rounded  mt-1.5 text-sm text-gray-700",
        }}
      />
    </div>
  );
};

export default BoardSelect;
